(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["noon-accordion-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('noon-accordion-video')) {
    customElements.define('noon-accordion-video', class extends HTMLElement {
      connectedCallback() {
        this.details = this.closest('details');
        this.onToggle = () => {
          if (!this.details.open) this.querySelector('video')?.pause();
        };
        this.details?.addEventListener('toggle', this.onToggle);
      }

      disconnectedCallback() {
        this.details?.removeEventListener('toggle', this.onToggle);
        this.querySelector('video')?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["noon-space-menu"] && !Shopify.designMode) return;
  try {
    function connectSpaceMenus(root) {
    root.querySelectorAll('.noon-space-nav details').forEach((menu) => {
      if (menu.dataset.connected) return;
      menu.dataset.connected = 'true';
      menu.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && menu.closest('.noon-space-nav--desktop')) menu.open = true;
      });
      menu.addEventListener('pointerleave', () => {
        if (menu.closest('.noon-space-nav--desktop') && !menu.contains(document.activeElement)) menu.open = false;
      });
      menu.addEventListener('focusout', (event) => {
        if (menu.closest('.noon-space-nav--desktop') && !menu.contains(event.relatedTarget)) menu.open = false;
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          menu.open = false;
          menu.querySelector('summary').focus();
          event.stopPropagation();
        }
      });
    });
  }
  connectSpaceMenus(document);
  document.addEventListener('shopify:section:load', (event) => connectSpaceMenus(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["noonaway-sale-moment"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('noon-sale-moment')) {
    customElements.define('noon-sale-moment', class extends HTMLElement {
      connectedCallback() {
        if (this.classList.contains('is-visible')) return;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.classList.add('is-visible');
            this.observer.disconnect();
          }
        }, { threshold: 0.25 });
        this.observer.observe(this);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('noon-size-recommendation')) {
  customElements.define('noon-size-recommendation', class extends HTMLElement {
    static choose(variants, config) {
      if (config.currency !== 'USD' || config.sizeIndex < 0 || config.frameIndex < 0 || !Number.isFinite(config.saleRate) || config.saleRate < 0 || config.saleRate >= 100) return null;
      const groups = new Map();
      for (const variant of variants) {
        const size = variant.options?.[config.sizeIndex], frame = String(variant.options?.[config.frameIndex] || '');
        const match = String(size).match(/(\d+(?:\.\d+)?)\s*[×xX]\s*(\d+(?:\.\d+)?)/);
        if (!variant.available || !match || !frame || /rolled|stretched|unframed|no frame|无框|卷筒/i.test(frame)) continue;
        const price = Number(variant.price), area = Number(match[1]) * Number(match[2]);
        if (!Number.isFinite(price) || price <= 0 || !(area > 0)) continue;
        const net = Math.round(price * (100 - config.saleRate) / 100);
        const group = groups.get(size);
        groups.set(size, {size, area, minimum: Math.min(group?.minimum ?? Infinity, net)});
      }
      return [...groups.values()].filter(group => group.minimum >= 60000).sort((a, b) => a.area - b.area || a.minimum - b.minimum)[0]?.size || null;
    }
    connectedCallback() {
      if (this.observer) return;
      try { this.config = JSON.parse(this.querySelector('[data-recommendation-config]').textContent); } catch { return; }
      this.scope = this.closest('product-info') || this.parentElement;
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this.scope, {childList: true, subtree: true});
      this.schedule();
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.observer = null;
      cancelAnimationFrame(this.pending);
    }
    schedule() {
      cancelAnimationFrame(this.pending);
      this.pending = requestAnimationFrame(() => this.update());
    }
    update() {
      const picker = document.getElementById(this.dataset.pickerId);
      if (!picker || !this.scope.contains(picker)) return;
      let variants;
      try { variants = JSON.parse(picker.querySelector('[data-variants]').textContent); } catch { return; }
      const choice = this.constructor.choose(variants, this.config);
      const group = picker.querySelector('[data-option-index="option' + (this.config.sizeIndex + 1) + '"]');
      const input = [...(group?.querySelectorAll('input[type="radio"]') || [])].find(item => item.value === choice && !item.disabled && !item.classList.contains('disabled'));
      const label = input ? [...group.querySelectorAll('label[for]')].find(item => item.htmlFor === input.id) : null;
      picker.querySelectorAll('[data-noon-size-recommended]').forEach(badge => {
        if (badge.parentElement !== label) { badge.parentElement.classList.remove('noon-recommended-size'); badge.remove(); }
      });
      if (!label || label.querySelector('[data-noon-size-recommended]')) return;
      label.classList.add('noon-recommended-size');
      const badge = document.createElement('span');
      badge.dataset.noonSizeRecommended = '';
      badge.className = 'noon-recommended-size__badge';
      badge.textContent = this.config.label;
      label.append(badge);
    }
  });
}

if (!customElements.get('noon-frame-guide')) {
  function frameGuideScale(value) { return Math.max(1, Math.min(4, Number(value) || 1)); }
  function frameGuidePan(value, size, scale) { const limit = size * (scale - 1) / 2; return Math.max(-limit, Math.min(limit, value)); }
  function frameGuidePinch(scale, start, distance) { return frameGuideScale(start > 0 ? scale * distance / start : scale); }
  function frameGuideSelection(index, count) {
    const current = Number.isInteger(index) && index >= 0 && index < count ? index : 0;
    return {index: current, previous: (current + count - 1) % count, next: (current + 1) % count};
  }
  customElements.define('noon-frame-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.panels = [...this.querySelectorAll('[data-guide-panel]')];
      this.choices = [...this.querySelectorAll('[data-guide-choice]')];
      this.state = frameGuideSelection(0, this.panels.length);
      this.view = 'full';
      this.zoom = this.querySelector('[data-zoom-dialog]');
      this.viewport = this.querySelector('[data-zoom-viewport]');
      this.zoomImage = this.querySelector('[data-zoom-image]');
      this.points = new Map();
      this.resetZoom();
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-guide-open')) this.dialog.showModal();
        if (button.hasAttribute('data-guide-close')) this.dialog.close();
        if (button.hasAttribute('data-guide-choice')) this.select(Number(button.dataset.guideChoice));
        if (button.hasAttribute('data-guide-prev')) this.select(this.state.previous);
        if (button.hasAttribute('data-guide-next')) this.select(this.state.next);
        if (button.hasAttribute('data-guide-view')) {
          this.view = button.dataset.guideView;
          this.querySelectorAll('[data-guide-image]').forEach(el => { el.hidden = el.dataset.guideImage !== this.view; });
          this.querySelectorAll('[data-guide-view]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.guideView === this.view)));
        }
        if (button.hasAttribute('data-guide-zoom')) {
          const source = this.panels[this.state.index].querySelector('[data-guide-image="' + this.view + '"]');
          this.zoomImage.src = source.dataset.zoomSrc;
          this.zoomImage.alt = source.querySelector('img').alt;
          this.resetZoom();
          this.zoom.showModal();
        }
        if (button.hasAttribute('data-zoom-close')) this.zoom.close();
        if (button.hasAttribute('data-zoom-reset')) this.resetZoom();
        if (button.hasAttribute('data-zoom-in')) this.setZoom(this.scale + .5);
        if (button.hasAttribute('data-zoom-out')) this.setZoom(this.scale - .5);
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      });
      this.zoom.addEventListener('close', () => this.resetZoom());
      this.viewport.addEventListener('pointerdown', e => {
        this.viewport.setPointerCapture(e.pointerId);
        this.points.set(e.pointerId, {x:e.clientX,y:e.clientY});
      });
      this.viewport.addEventListener('pointermove', e => {
        if (!this.points.has(e.pointerId)) return;
        const previous = this.points.get(e.pointerId);
        const old = [...this.points.values()];
        this.points.set(e.pointerId, {x:e.clientX,y:e.clientY});
        const next = [...this.points.values()];
        if (next.length === 2) {
          const distance = pair => Math.hypot(pair[0].x-pair[1].x,pair[0].y-pair[1].y);
          this.setZoom(frameGuidePinch(this.scale, distance(old), distance(next)));
        } else {
          this.x += e.clientX - previous.x; this.y += e.clientY - previous.y; this.paintZoom();
        }
      });
      ['pointerup','pointercancel','lostpointercapture'].forEach(type => this.viewport.addEventListener(type, e => this.points.delete(e.pointerId)));
      this.viewport.addEventListener('wheel', e => { e.preventDefault(); this.setZoom(this.scale - e.deltaY*.005); }, {passive:false});
      this.viewport.addEventListener('keydown', e => {
        if (['+','=','-','0','ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(e.key)) e.preventDefault();
        if (e.key === '+' || e.key === '=') this.setZoom(this.scale+.5);
        if (e.key === '-') this.setZoom(this.scale-.5);
        if (e.key === '0') this.resetZoom();
        if (e.key === 'ArrowLeft') this.x+=40;
        if (e.key === 'ArrowRight') this.x-=40;
        if (e.key === 'ArrowUp') this.y+=40;
        if (e.key === 'ArrowDown') this.y-=40;
        this.paintZoom();
      });
    }
    resetZoom() { this.scale=1; this.x=0; this.y=0; this.points.clear(); this.paintZoom(); }
    setZoom(value) { this.scale=frameGuideScale(value); this.paintZoom(); }
    paintZoom() {
      this.x=frameGuidePan(this.x,this.viewport.clientWidth,this.scale);
      this.y=frameGuidePan(this.y,this.viewport.clientHeight,this.scale);
      this.zoomImage.style.transform='translate('+this.x+'px,'+this.y+'px) scale('+this.scale+')';
    }
    select(index) {
      this.state = frameGuideSelection(index, this.panels.length);
      this.panels.forEach((panel, i) => {panel.hidden = i !== this.state.index;});
      this.choices.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.state.index)));
      this.querySelector('[data-guide-count]').textContent = (this.state.index + 1) + ' / ' + this.panels.length;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
